import { useMemo, useState } from 'react';
import moment from 'moment';
import { useMount } from 'ahooks';
import { getQueryDefinition } from '@intelligence/services/common';

const getYearlyPosterRemoveDate = async () => {
  let date = '';
  try {
    const res = await getQueryDefinition({
      common: {
        target: 'game_config',
        params: {
          key: 'home_yearly_poster_remove_date',
        },
      },
    });
    date = res?.data?.common?.home_yearly_poster_remove_date || '';
  } catch (error) {
    console.error(error);
    date = '';
  }

  return date;
};

export default function useYearlyPoster() {
  const [loading, setLoading] = useState(true);
  // 2025年度表彰下架日期
  const [removeDate, setRemoveDate] = useState('');

  // 是否展示2025年度表彰
  const show = useMemo<boolean>(() => {
    if (loading) {
      return false;
    }

    if (!removeDate) {
      return false;
    }

    const removeDateM = moment(removeDate);

    if (!removeDateM.isValid()) {
      return false;
    }

    // 当前日期不超过下架日期就展示
    return moment().isSameOrBefore(removeDateM);
  }, [loading, removeDate]);

  useMount(async () => {
    setLoading(true);
    const date = await getYearlyPosterRemoveDate();
    setRemoveDate(date);
    setLoading(false);
  });

  return { loading, removeDate, show };
}
